'use client'

import type {
	SRT_Cell,
	SRT_ColumnMeta,
	SRT_RowData,
} from '../../../../../shared/components/master-table'

import { useMemo } from 'react'
import { CheckIcon, XIcon } from 'lucide-react'

import { intlFormat } from '@/shared/tools/dates'

export function ShortTextCell<TData extends SRT_RowData>({
	cell,
	tableMeta,
}: {
	cell: SRT_Cell<TData>
	tableMeta: SRT_ColumnMeta
}) {
	const initialValue = useMemo(() => {
		const _value = cell.getValue() as string
		if (tableMeta.options?.length) {
			return (
				tableMeta.options.find((option) => option.value === _value)?.label ??
				_value
			)
		}

		return _value
	}, [cell, tableMeta])

	const displayValue = initialValue ?? ''

	return <div role='textbox'>{displayValue}</div>
}
export function NumberCell<TData extends SRT_RowData>({
	cell,
}: {
	cell: SRT_Cell<TData>
}) {
	const initialValue = cell.getValue() as string
	const displayValue = initialValue ?? ''

	return (
		<div role='textbox' className='text-right font-mono'>
			{displayValue}
		</div>
	)
}
export function CheckboxCell<TData extends SRT_RowData>({
	cell,
}: {
	cell: SRT_Cell<TData>
}) {
	const initialValue = cell.getValue() as string
	const displayValue = initialValue ?? ''

	return (
		<div role='textbox'>
			{displayValue ? (
				<CheckIcon className='size-3 text-success' />
			) : (
				<XIcon className='size-3 text-destructive' />
			)}
		</div>
	)
}

export function SelectCell<TData extends SRT_RowData>({
	cell,
	tableMeta,
}: {
	cell: SRT_Cell<TData>
	tableMeta: SRT_ColumnMeta
}) {
	const initialValue = useMemo(() => {
		const _value = cell.getValue() as string
		if (tableMeta.options?.length) {
			return (
				tableMeta.options.find((option) => option.value === _value)?.label ??
				_value
			)
		}

		return _value
	}, [cell, tableMeta])

	const displayValue = initialValue ?? ''

	return <div role='textbox'>{displayValue}</div>
}
export function DateCell<TData extends SRT_RowData>({
	cell,
}: {
	cell: SRT_Cell<TData>
}) {
	const initialValue = cell.getValue() as string
	const displayValue = initialValue ? intlFormat(new Date(initialValue)) : '-'

	return <div role='textbox'>{displayValue}</div>
}
export function MultiSelectCell<TData extends SRT_RowData>({
	cell,
}: {
	cell: SRT_Cell<TData>
}) {
	const initialValue = cell.getValue() as string
	const displayValue = initialValue ?? ''

	return <div role='textbox'>{displayValue}</div>
}
